import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Antd from "ant-design-vue";
import store from "./store/store.js";
import "ant-design-vue/dist/reset.css";

createApp(App).use(router).use(Antd).use(store).mount("#app");
